import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { Icon } from 'components/shared/Icon/Icon'

import type { IconSource } from 'components/shared/Icon/Icon'

import styles from './CategoryStatistics.module.scss'

type CategoryStatisticsProps = {
  children?: React.ReactNode
  editButton?: React.ReactNode
  className?: string
  icon: IconSource
  label: React.ReactNode
  value: React.ReactNode
}

export const CategoryStatistics = ({
  children,
  editButton,
  className,
  icon,
  label,
  value,
}: CategoryStatisticsProps) => (
  <React.Fragment>
    <Box
      align="center"
      className={cx(styles.category, {
        [className ?? '']: Boolean(className),
      })}
    >
      <Icon className={styles.icon} icon={icon} size={24} />
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
      {editButton}
    </Box>
    {children != null ? children : null}
  </React.Fragment>
)
